import { render, staticRenderFns } from "./PoiMap.vue?vue&type=template&id=81a8b998&scoped=true&"
import script from "./PoiMap.vue?vue&type=script&lang=js&"
export * from "./PoiMap.vue?vue&type=script&lang=js&"
import style0 from "./PoiMap.vue?vue&type=style&index=0&id=81a8b998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a8b998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
